import { BookingFlow } from '@/components/booking/BookingFlow';
import { useCompanyBySlug } from '@/hooks/queries/useCompanyBySlug';
import type { BookingLocationState } from '@/types/booking-location-state';
import { useLocation, useParams } from 'react-router-dom';

const Booking = () => {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const { company } = useCompanyBySlug(slug);
  const locationState = (location.state as BookingLocationState | null) ?? null;

  return <BookingFlow company={company} initialState={locationState} variant="standalone" />;
};

export default Booking;
